import { ExaminationGrade } from "../../../Examination/Enums/ExaminationGrade";
import { getDateWithOffset } from "../../../Shared/Utility/GetDateWithOffset";
import { CCArticleResult } from "../../Models/Assessment";


export class AbccAssessment{
    abccAssessmentId: number;
    physicianId: number;
    certificateId: number;
    startDate: string;
    endDate: string;
    grade: ExaminationGrade;
    abccAssessmentStatusId: AbccAssessmentStatus;
    modules: Array<AbccAssessmentModule>;

    constructor(data: Partial<AbccAssessment>) {
        Object.assign(this, data);
        // Ensure modules are properly constructed
        this.modules = (data.modules || []).map(module => new AbccAssessmentModule(module));
    }

    isMissingModule = () => {
        const assessmentEndYear = new Date(this.endDate).getFullYear();
        const maxModuleEndYear = Math.max(...this.modules.map(module => new Date(module.endDate).getFullYear()));
        return (maxModuleEndYear - assessmentEndYear) > 2;
    }
}

export class AbccAssessmentModule{
    abccAssessmentModuleId: number;
    abccAssessmentId: number;
    startDate: string;
    endDate: string;
    oasisLearningTrackId: number;
    grade: ExaminationGrade;
    isCatchUp: boolean;
    attestationDate: string
    ccArticleResults: Array<CCArticleResult>;
    requiredArticlesPerModule: number;
    maxFailedArticlesAllowedPerModule: number;

    constructor(data: Partial<AbccAssessmentModule>) {
        Object.assign(this, data);
    }

    isCurrent = () => {
        let startDate = getDateWithOffset(this.startDate);
        let endDate = getDateWithOffset(this.endDate);
        let now = new Date();
        
        return (startDate <= now && now <= endDate);
    }

}

export enum AbccAssessmentStatus{
    AuthorizationPending = 1,
    Authorized = 2,
    Delivered = 3,
    GradingComplete = 4,
    UnderReview = 5,
    Exited = 6,
    Denied = 7,
    Withdrawn = 8,
    ChangedPathway = 9
}